// Jun 2026 (Randy pt-voucher-lots Pass 3) — creator-facing available / held /
// total credit strip.
//
// WHY IT EXISTS: when a card dispute is opened, the disputed credit is FROZEN —
// it leaves the spendable provider buckets so it cannot be burned, transferred,
// redistributed, shifted or withdrawn while the bank might pull the money back.
// Without this strip the creator's balance would appear to shrink for no
// visible reason.
//
// The wording below is Randy's APPROVED copy (Draft 2 of the four voucher
// policy drafts). It must stay consistent with the checkout disclosure in
// VoucherTopupModal, /refund-policy and the Terms. Do not reword unilaterally.
import { Lock } from "@phosphor-icons/react";

const fmt$ = (cents) => `$${((cents || 0) / 100).toFixed(2)}`;

export default function VoucherHeldStrip({ availableCents, heldCents, disputeCount = 0, context = "dashboard" }) {
  const held = Number(heldCents || 0);
  if (held <= 0) return null;
  const available = Number(availableCents || 0);
  const total = available + held;

  return (
    <div
      className="mb-3 rounded-lg border border-[#E0C79A] bg-[#FDF8EE] px-3 py-2.5"
      data-testid={`voucher-held-strip-${context}`}
    >
      <div className="flex items-center gap-2 mb-2">
        <Lock size={13} weight="duotone" className="text-[#8A5A00] shrink-0" />
        <span className="text-[11px] font-medium text-[#1C1B1A]" data-testid="voucher-held-strip-title">
          Some of your credit is on hold
        </span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <Figure label="Available" cents={available} testid="voucher-held-available" tone="#1C1B1A" />
        <Figure label="Held pending review" cents={held} testid="voucher-held-held" tone="#8A5A00" />
        <Figure label="Total" cents={total} testid="voucher-held-total" tone="#4A5D4E" />
      </div>
      <div className="mt-2 text-[10px] leading-snug text-[#6B6A68]" data-testid="voucher-held-strip-explainer">
        Your bank has opened a dispute on one of your top-ups
        {disputeCount > 0 ? ` (${disputeCount} silo${disputeCount === 1 ? "" : "s"} affected)` : ""},
        so the credit from that payment is held while it's reviewed. Held credit still belongs
        to you, but while it's on hold it can't be spent on AI, moved between silos or providers,
        or withdrawn as cash. Everything else on your account works normally. If the dispute
        closes in your favor, the credit is released automatically — you don't need to do anything.
      </div>
    </div>
  );
}

function Figure({ label, cents, testid, tone }) {
  return (
    <div className="rounded-md bg-white/70 border border-[#EADFC7] px-2 py-1.5" data-testid={testid}>
      <div className="text-[9px] uppercase tracking-[0.16em] text-[#6B6A68]">{label}</div>
      <div className="font-mono tabular-nums text-sm mt-0.5" style={{ color: tone }}>
        {fmt$(cents)}
      </div>
    </div>
  );
}
